import React from "react";

/**
 * What the Übersicht says when the selected period has no answerable window (P3b).
 *
 * "Gesamte Zeit" is unbounded, and every period contract behind this tab is bounded
 * at 24 months — expected revenue is folded per month, occupancy needs a denominator,
 * and neither has an all-time form.
 *
 * WHY THIS IS A STATE AND NOT A FALLBACK
 * --------------------------------------
 * The tab used to answer an unanswerable period with the range's TO-month, which is
 * how a filter reading "April – September 2026" came to show September's figures.
 * Quietly substituting "the last 24 months" would be the same mistake with a longer
 * window: a figure on screen that the label above it does not name.
 *
 * WHY IT IS A LINE AND NOT A PAGE
 * -------------------------------
 * Unlike Performance, which replaces its whole tab, the Übersicht still has real
 * answers in this mode — open receivables, the live occupancy snapshot, cash
 * deposits, warnings, the data-source status and the payment feed are all current
 * state and none of them needed a period in the first place. Blanking the tab would
 * hide five working figures to explain four missing ones. So this states the limit
 * once, above the grid, and the period cards below it show a dash.
 */
export default function OverviewPeriodUnsupported() {
  return (
    <p
      data-testid="overview-period-unsupported"
      className="rounded-xl border border-border bg-card px-3 py-2 text-[12px] leading-snug text-muted-foreground"
    >
      Periodenkennzahlen sind für ausgewählte Zeiträume bis 24 Monate verfügbar.
      Bitte wähle einen Zeitraum. Aktuelle Werte — offene Forderungen, Auslastung,
      Barkautionen und Hinweise — bleiben unverändert sichtbar.
    </p>
  );
}
